import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAgentsFromRolesAPI } from "../api/hub_manager";
import { getDriverFleetList } from "../api/fleet";
import { notify } from "shared/utils/notify";
export const getAgentsListFromRole = createAsyncThunk(
  "dashboard/agents/list",
  async ({ role, hubId, limit }) => {
    try {
      // if (!hubId) {
      //   return { role: role, data: [] };
      // }
      const response = await getAgentsFromRolesAPI(role, hubId, limit);
      return { role: role, data: response.results };
    } catch (error) {
      //
      // return { entity, error: error.message };
      return error;
    }
  }
);

export const getCarList = createAsyncThunk(
  "dashboard/car/list",
  async ({ driverId, limit, page, vehicleAssignId, vehicle_assign_id, requestId, request_id }) => {
    try {
      // const response = await carListAPI(hubId);
      const response = await getDriverFleetList(
        driverId,
        vehicleAssignId || vehicle_assign_id || requestId || request_id
      );

      return response.results;
    } catch (error) {
      //
      // return { entity, error: error.message };
      notify.info({
        message: "Swap vehicle options error!",
        description:
          error?.message ||
          error?.data?.message ||
          "Error occured while getting swap vehicle options",
        placement: "bottomRight",
      });
      // return error;
    }
  }
);

const agentsListSlice = createSlice({
  name: "allocationOptions",
  initialState: {
    data: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAgentsListFromRole.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAgentsListFromRole.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data[action.payload?.role] = action.payload.data;
    });
    builder.addCase(getAgentsListFromRole.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

const carListSlice = createSlice({
  name: "carListSlice",
  initialState: {
    data: [],
    error: null,
    isLoading: false,
  },
  reducers: {
    updateCarList: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCarList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCarList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getCarList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});
const hubManager_Data = createSlice({
  name: "hubManagerData",
  initialState: {
    allocationsData: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    updateAllocationData: (state, action) => {
      state.allocationsData = action.payload.allocationsData;
    },
  },
  // extraReducers: (builder) => {
  //     builder.addCase(getCarList.pending, (state) => {
  //         state.isLoading = true;
  //     });
  //     builder.addCase(getCarList.fulfilled, (state, action) => {
  //         state.isLoading = false;
  //         state.data = action.payload;
  //     });
  //     builder.addCase(getCarList.rejected, (state, action) => {
  //         state.isLoading = false;
  //         state.error = action.error;
  //     });
  // },
});
export const reduxCarList = carListSlice.reducer;
export const agentsLists = agentsListSlice.reducer;
export const hubManagerData = hubManager_Data.reducer;
export const updateAllocationData = hubManager_Data.actions.updateAllocationData;
export const updateCarList = carListSlice.actions.updateCarList;
